import { useTranslation } from "react-i18next";

/** Scores in the reader's grouping: "21,880" in English, "21 880" in French. */
export function useNumber(): (value: number) => string {
  const { i18n } = useTranslation();
  const format = new Intl.NumberFormat(i18n.resolvedLanguage ?? i18n.language);
  return (value) => format.format(value);
}
